"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CENTER = exports.MIDDLE = exports.RIGHT = exports.LEFT = exports.BOTTOM = exports.TOP = exports.GOLDEN_RATIO = exports.RIGHT_ANGLE = exports.TAU = exports.DEFAULT_CSS_CURSOR = void 0;
exports.DEFAULT_CSS_CURSOR = 'default';
exports.TAU = 2 * Math.PI;
exports.RIGHT_ANGLE = exports.TAU / 4;
exports.GOLDEN_RATIO = 1.618;
exports.TOP = 'top';
exports.BOTTOM = 'bottom';
exports.LEFT = 'left';
exports.RIGHT = 'right';
exports.MIDDLE = 'middle';
exports.CENTER = 'center';
//# sourceMappingURL=constants.js.map